import(/* webpackMode: "eager" */ "/app/src/app/company/team/page.tsx");
